import { defineComponent } from 'vue';
import JsonEditorVue from 'json-editor-vue';

export default defineComponent({
  name: 'JsonEditor',
  components: { JsonEditorVue },
  props: {
    jsonData: {
      type: Object as () => Record<string, string>,
      required: true,
    },
  },
});
